import React, { useCallback, useContext } from "react";
import { UserContext } from "../../appContext";
import { useNavigate } from "react-router-dom";
import './settingsPage.scss'

type TSettingsPageProps = {
    setBeta: (v: boolean) => void;
}

export const SettingsPage = ({setBeta}: TSettingsPageProps) => {
    const {loggedIn, logOut} = useContext(UserContext);
    const navigate = useNavigate();
    const onLogOut = useCallback(() => {
        logOut(() => navigate('/'));
    }, [logOut, navigate]);
    return <>
        <div className="beta-button-container" style={{textAlign: "right"}}>
            <button onClick={() => setBeta(false)}>Exit Beta</button>
        </div>
        <div className="settings-page">
            {loggedIn ? <button onClick={onLogOut}>Log out</button> : "Oooops"}
        </div>
    </>
}